import * as cfe from 'ego-cfe';
import React from 'react';

import { useUserMeInternalRaw } from './hooks/useUserMeInternal';

const UserGate = (props: { children: React.ReactNode; fallback: React.ReactNode }) => {
  const [userMe, _] = useUserMeInternalRaw();
  return <>{userMe === null || cfe.ApiData.hasData(userMe) ? props.children : props.fallback}</>;
};

export default UserGate;
